import { render, staticRenderFns } from "./AverbacaoBusca.vue?vue&type=template&id=0d7d53a6&scoped=true&"
import script from "./AverbacaoBusca.vue?vue&type=script&lang=js&"
export * from "./AverbacaoBusca.vue?vue&type=script&lang=js&"
import style0 from "./AverbacaoBusca.vue?vue&type=style&index=0&id=0d7d53a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7d53a6",
  null
  
)

export default component.exports